import React, { useContext, useState, useEffect } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";

const ElementSettingsLogo = (props) => {
  const [contextData, builder, setContextData] = useContext(VariantContextData);
  let website = contextData.objects.website;
  let variant = contextData.objects.variant;
  let element = builder.selected().object;
  let section = variant.sections[element.section_id];

  let controlStyleMobile = element.options["control-style-mobile"]
    ? element.options["control-style-mobile"]
    : element.options["control-style"]
      ? element.options["control-style"]
      : "width";

  return (
    <React.Fragment>

      <VariantBuilderSetting
        object={element}
        setting_name="[options][logo-format]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        label="Logo Format"
        value={element.options["logo-format"] ? element.options["logo-format"] : variant.options["logo-format"] ? variant.options["logo-format"] : null}
        placeholder={variant.options["logo-format"]}
        options={[
          { value: "image", text: "Image" },
          { value: "icon", text: "Icon" },
        ]}
        show_reset={element.options["logo-format"] !== null}
      />


      <VariantBuilderSetting
        object={element}
        setting_name="[options][logo-style]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        label="Logo Style"
        value={element.options["logo-style"] ? element.options["logo-style"] : variant.options["logo-style"] ? variant.options["logo-style"] : null}
        placeholder={variant.options["logo-style"]}
        options={[
          { value: "dark", text: "Dark Brand Style" },
          { value: "light", text: "Light Brand Style" },
          { value: "custom", text: "Custom Image Upload" },
        ]}
        show_reset={element.options["logo-style"] !== null}
      />

      {element.options["logo-style"] !== "custom" && (
        <div className="row hard-center">
          <div className="col-xs-12">
            <p className="text-base text-black">
              Upload light/dark logos in website <a href={`/websites/${website.id}/edit`} target='_blank'>settings →</a>
            </p>
          </div>
        </div>
      )}

      <VariantBuilderSetting
        object={element}
        setting_name="[options][logo-image]" 
        setting_type="image"
        object_type="elements"
        object_id={element.id}
        label="Custom Image URL"
        value={element.options["logo-image"] ? element.options["logo-image"] : null}
        placeholder={variant.options["logo-image"]}
        callback={() => {
          builder.update([
            {
              object_type: "elements",
              object_id: element.id,
              setting_name: "[options][logo-style]",
              value: "custom",
            },
          ]);
        }}
      />

      <VariantBuilderSetting
        object={element}
        label="Control"
        setting_name="[options][control-style]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        value={
          element.options["control-style"]
            ? element.options["control-style"]
            : variant.options["logo-control-style"] ? variant.options["logo-control-style"] : null
        }
        placeholder={variant.options["logo-control-style"]}
        options={[
          { value: "width", text: "Width" },
          { value: "height", text: "Height" },
        ]}
        device="desktop"
        show_reset={element.options["control-style"] !== null}
      />

      <VariantBuilderSetting
        object={element}
        label="Control"
        setting_name="[options][control-style-mobile]"
        setting_type="dropdown"
        object_type="elements"
        object_id={element.id}
        value={element.options["control-style-mobile"] ? element.options["control-style-mobile"] : variant.options["logo-control-style-mobile"] ? variant.options["logo-control-style-mobile"] : variant.options["logo-control-style"] ? variant.options["logo-control-style"] : null}
        placeholder={element.options["control-style"] ? element.options["control-style"] : variant.options["logo-control-style-mobile"] ? variant.options["logo-control-style-mobile"] : variant.options["logo-control-style"]}
        options={[
          { value: "width", text: "Width" },
          { value: "height", text: "Height" },
        ]}
        device="mobile"
        show_reset={element.options["control-style-mobile"] !== null}
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][image-width]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label={"Logo Max Width"}
        value={element.options["image-width"]}
        device="desktop"
        condition={
          element.options["control-style"] !== "height" &&
          ["logo"].includes(element.element_type)
        }
        placeholder={variant.options["logo-image-width"] ? variant.options["logo-image-width"] : "Auto"}
        min={0}
        max={2560}
        allow_empty={true}
        range_step={"1"}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][image-width-mobile]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label={"Logo Max Width"}
        condition={controlStyleMobile == "width"}
        placeholder={element.options["image-width"] ? element.options["image-width"] : variant.options["logo-image-width"] ? variant.options["logo-image-width"] : "Auto"}
        value={
          element.options["image-width-mobile"]
            ? element.options["image-width-mobile"]
            : undefined
        }
        device="mobile"
        min={0}
        max={2560}
        allow_empty={true}
        range_step={"1"}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][image-height]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label={"Logo Max Height"}
        value={element.options["image-height"]}
        device="desktop"
        condition={
          element.options["control-style"] == "height" &&
          ["logo"].includes(element.element_type)
        }
        placeholder={variant.options["logo-image-height"] ? variant.options["logo-image-height"] : "Auto"}
        min={0}
        max={2560}
        allow_empty={true}
        range_step={"1"}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={section}
        setting_name="[options][image-height-mobile]"
        setting_type="range"
        object_type="elements"
        object_id={element.id}
        label={"Logo Max Height"}
        condition={controlStyleMobile == "height"}
        placeholder={element.options["image-height"] ? element.options["image-height"] : variant.options["logo-image-height"] ? variant.options["logo-image-height"] : "Auto"}
        value={
          element.options["image-height-mobile"]
            ? element.options["image-height-mobile"]
            : undefined
        }
        device="mobile"
        min={0}
        max={2560}
        allow_empty={true}
        range_step={"1"}
        show_reset={true}
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][logo-link]"
        setting_type="text"
        object_type="elements"
        object_id={element.id}
        label="Logo Link"
        placeholder={variant.options["logo-link"] ? variant.options["logo-link"] : "https://"}
        value={element.options["logo-link"] ? element.options["logo-link"] : undefined}
        allow_empty={true}
        show_reset={true}
      >
        <VariantBuilderSetting
          object={element}
          setting_name="[options][logo-link-new-tab]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          label="Open in New Tab"
          value={element.options["logo-link-new-tab"]}
          show_reset={true}
          classNames="!w-[250px]"
        />
      </VariantBuilderSetting>

      <VariantBuilderSetting
        object={element}
        setting_name="[options][alt-text]"
        setting_type="text"
        object_type="elements"
        object_id={element.id}
        label="Logo Alt Text"
        placeholder={variant.options["logo-alt-text"] ? variant.options["logo-alt-text"] : "Image Alt Text"}
        value={element.options["alt-text"]}
        condition={element.element_type == "logo"}
        allow_empty={true}
      />
    </React.Fragment>
  );
};

export default ElementSettingsLogo;
